document.addEventListener('DOMContentLoaded', () => {
  // Form elements
  const form = document.querySelector('form');
  const countrySelect = document.getElementById('Contactcountry');
  const vatInput = document.getElementById('Contactvat_number');
  const companyInput = document.getElementById('Contactcompany');
  const addressInput = document.getElementById('Contactaddress');
  const cityInput = document.getElementById('Contactcity');
  const postalCodeInput = document.getElementById('Contactzip_code');
  const phoneInput = document.getElementById('Contactphone');
  const loader = document.querySelector('.itemloadervat');
  
  let isLoading = false;
  let validateTimeout;

  // Initialize
  setupVatValidation();
  updateVatPlaceholder();
  updateTemplateVisibility();

  // Set up event listeners
  countrySelect.addEventListener('change', () => {
    updateVatPlaceholder();
    updateTemplateVisibility();
  });

  // Add input event listener with debounce
  vatInput.addEventListener('input', () => {
    clearTimeout(validateTimeout);
    validateTimeout = setTimeout(() => {
      validateVatNumber(vatInput.value);
    }, 500);
  });

  vatInput.addEventListener('blur', () => {
    clearTimeout(validateTimeout);
    validateVatNumber(vatInput.value);
  });

  function updateTemplateVisibility() {
    const country = countrySelect.value;
    const isBelgium = country === 'Belgium';
    
    // Handle Belgium-specific fields
    const belgiumFields = document.querySelectorAll('[data-belgium-only]');
    belgiumFields.forEach(field => {
      field.style.display = isBelgium ? 'flex' : 'none';
    });

    // Handle non-Belgium fields (like Chamber of Commerce)
    const nonBelgiumFields = document.querySelectorAll('[data-non-belgium]');
    nonBelgiumFields.forEach(field => {
      field.style.display = !isBelgium ? 'block' : 'none';
      // Update required attribute based on visibility
      const input = field.querySelector('input');
      if (input) {
        input.required = !isBelgium;
      }
    });
  }

  function updateVatPlaceholder() {
    const country = countrySelect.value;
    if (country === 'Belgium') {
      vatInput.placeholder = 'B01BE1234567890';
    } else if (country === 'Netherlands') {
      vatInput.placeholder = 'NL123456789';
    } else {
      vatInput.placeholder = '';
    }
  }

  function setupVatValidation() {
    const style = document.createElement('style');
    style.textContent = `
      input.green { border-color: rgb(34 197 94) !important; }
      input.red { border-color: rgb(239 68 68) !important; }
      .loading-spinner {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        scale: 0.5;
      }
    `;
    document.head.appendChild(style);
  }

  async function validateVatNumber(vat) {
    console.log('Starting VAT validation for:', vat);
    if (!vat || vat.length <= 8) {
      console.log('VAT number too short, skipping validation');
      vatInput.classList.remove('green', 'red');
      return;
    }

    if (isLoading) {
      console.log('Already validating, skipping');
      return;
    }
    
    isLoading = true;
    loader.style.display = 'block';
    vatInput.disabled = true;
    console.log('Loading state set to:', isLoading);

    try {
      const formattedVat = vat.replace(/\s/g, '').toUpperCase();
      console.log('Formatted VAT:', formattedVat);
      
      const url = `https://controleerbtwnummer.eu/api/validate/${encodeURIComponent(formattedVat)}.json`;
      console.log('Fetching from URL:', url);
      
      const response = await fetch(url);
      console.log('Response status:', response.status);
      
      if (!response.ok) throw new Error(`VAT validation failed: ${response.status}`);
      
      const data = await response.json();
      console.log('Validation response:', data);
      
      vatInput.classList.remove('green', 'red');
      vatInput.classList.add(data.valid ? 'green' : 'red');
      
      if (data.valid && data.company) {
        console.log('Company data received:', data.company);
        companyInput.value = data.company.name || '';
        addressInput.value = data.company.address || '';
        cityInput.value = data.company.city || '';
        postalCodeInput.value = data.company.postalCode || '';
      }
    } catch (error) {
      console.error('VAT validation error:', error);
      vatInput.classList.remove('green');
      vatInput.classList.add('red');
    } finally {
      isLoading = false;
      loader.style.display = 'none';
      vatInput.disabled = false;
      console.log('Loading state finished:', isLoading);
    }
  }
});
